import API from '@services/API';

const RelatorioService = {
  controles: async (processo, filters) => await API.filters(`${processo}/relatorios/controles`, filters),
	quantitativoGeral: async (processo, filters) => await API.filters(`${processo}/relatorios/quantitativoGeral`, filters),
	quantitativoTransferidoObmep: async (processo, filters) => await API.filters(`${processo}/relatorios/quantitativoTransferidoObmep`, filters),
	quantitativoTratamentoNome: async (processo) => await API.list(`${processo}/relatorios/quantitativoTratamentoNomes`),
  quantitativoTratamentoNomesDuplicados: async (processo) => await API.list(`${processo}/relatorios/quantitativoTratamentoNomesDuplicados`),
  quantitativoTratamentoDataNascimento: async (processo) => await API.list(`${processo}/relatorios/quantitativoTratamentoDataNascimento`),
  quantitativoTratamentoCPF: async (processo) => await API.list(`${processo}/relatorios/quantitativoTratamentoCpf`),
  quantitativoPorData: async (processo, filters) => await API.filters(`${processo}/relatorios/quantitativoPorData`, filters),
  desempenhoPorData: async (processo, filters) => await API.filters(`${processo}/relatorios/desempenhoPorData`, filters),
}

export default RelatorioService;
